import './CopilotModal.scss';
class CopilotModalController {
    static $inject = ['command', 'close', 'confirm', 'clickOnlearnMoreAboutCopilot'];
    constructor(command, close, confirm, clickOnlearnMoreAboutCopilot) {
        this.command = command;
        this.close = close;
        this.confirm = confirm;
        this.clickOnlearnMoreAboutCopilot = clickOnlearnMoreAboutCopilot;
        this.isProcessing = false;
        this.isProccessFail = false;
        this.onCommandChange = (event) => {
            this.command = event.detail.value;
        };
        this._close = this.close;
    }
    async $onInit() {
        this.addEvents();
    }
    addEvents() {
        const modal = document.querySelector('#copilot-modal');
        modal.addEventListener('bdsModalChanged', e => { modal.remove(); });
        document.getElementById('copilot-modal-command').addEventListener('bdsChange', (e) => { this.onCommandChange(e); });
    }
    async _confirm() {
        this.isProccessFail = false;
        try {
            this.isProcessing = true;
            await this.confirm(this.command);
            this._close();
        }
        catch (e) {
            this.isProccessFail = true;
        }
        this.isProcessing = false;
    }
    async cancel() {
        this._close();
    }
    hasCommand() {
        const MIN_COMMAND_LENGTH = 5;
        return this.command && this.command.trim() !== '' && this.command.length > MIN_COMMAND_LENGTH && !this.isProcessing;
    }
}
CopilotModalController.$inject = ['command', 'close', 'confirm', 'clickOnlearnMoreAboutCopilot'];
export default CopilotModalController;
